import Axios from 'axios';
import { openReport } from '../../../utils/sessionGuard'; // セッション失効時は新タブを開かず現在の画面でログインへ
import React, { Fragment, useEffect, useState, useRef } from 'react';
// import Vimeo from '@vimeo/vimeo';
import {
  Card,
  Col,
  Row,
  Tooltip,
  Spin,
  message,
  Modal,
  Typography,
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import config from '../../Config/key';
import Vimeo from '@u-wave/react-vimeo';
const { Title, Text } = Typography;
const { confirm } = Modal;

// var Vimeo = require('vimeo').Vimeo;
function Course90502Page(props) {
  const [viewModal, setViewModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [paused, setPaused] = useState(false);
  const [videoId, setVideoId] = useState('');
  const playerRef = useRef(null); // Vimeoプレイヤーの参照を保持
  const thumbnailURL = `${config.S3_URL}/${config.S3_ENV}/videos/fixedThumbnail/`;
  let sendData = props.location.state;
  const { userData } = props.user;
  let tokenInfo = props.location.state.tokenInfo;
  let surveyStatus = sendData.tokenInfo.survey_status === 5 ? true : false;

  // モーダルを閉じる前にビデオを完全に停止
  const closeModal = () => {
    // プレイヤーが存在する場合、明示的に一時停止
    if (playerRef.current) {
      try {
        playerRef.current.pause();
        playerRef.current.unload(); // ビデオを完全にアンロード
      } catch (error) {
        console.log('ビデオ停止エラー:', error);
      }
    }

    // プレイヤー参照をクリア
    playerRef.current = null;

    // 状態をリセット
    setVideoId(''); // ビデオIDをリセット
    setPaused(false); // paused状態を初期化

    // 少し遅延してモーダルを閉じる
    setTimeout(() => {
      setViewModal(false);
    }, 100);
  };

  // モーダルでのOK
  const handleOk = (e) => {
    closeModal();
  };

  const handleCancel = (e) => {
    closeModal();
  };

  // カードクリック時の処理 - 新しいビデオを設定してモーダルを開く
  const handleCardClick = (v) => {
    // console.log(v);
    if (v === 'takeSurvey') {
      sendData.tokenInfo.survey_code = '50020';
      // console.log({ sendData });
      props.history.push({
        pathname: '/newtakesurvey',
        state: sendData,
      });
    } else {
      setVideoId(v);
      setPaused(false);
      setViewModal(true);
    }
  };

  // Vimeoプレイヤーの準備完了時の処理
  const handleReady = (player) => {
    playerRef.current = player;
  };

  const showConfirm = async () => {
    confirm({
      title: 'サーベイ結果を生成しますか？',
      content:
        'サーベイ結果を生成し別TabでPDF表示します。このままお待ちください。',
      async onOk() {
        setIsModalVisible(true);
        let ti = tokenInfo;
        // ti.group_name = userData.company;
        // ti.company = userData.company;
        // ti.survey_end_date = tokenInfo.updateAt;
        ti.survey_name = tokenInfo.surveyName;
        ti.emp_no = userData.empNo;
        ti.department = userData.department;
        ti.user_name = userData.lastname + ' ' + userData.name;
        let result = await Axios.post('/api/dbModel100/makeReport50020', ti);
        // console.log({ result });
        if (result.data.success) {
          // message.success('結果生成が完了しました。マイ・サーベイに戻ります。');
          // props.history.push('/mysurvey');
          // サーバープロキシ経由でPDFを表示（S3 URLを露出しない）
          message.success({
            content: 'ファイル生成完了！',
            key: 'makecsv',
            duration: 2,
          });
          setIsModalVisible(false);
          openReport(result.data.tokenId);
        } else {
          setIsModalVisible(false);
          console.log('結果生成で問題が発生しました。');
          message.error('結果生成で問題が発生しました。');
        }
      },
      async onCancel() {},
    });
  };

  return (
    <Fragment>
      <div style={{ width: '90%', margin: '1rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>パーソナリティー診断プログラム</Title>
        </div>
        {sendData.tokenInfo.coursePartView[0] ? (
          <Card
            title="パーソナリティー診断"
            styles={{ header: { backgroundColor: 'var(--blue-active)', color: 'var(--white)' }, body: { backgroundColor: 'var(--brand-cream)' } }}
            extra={
              <Tooltip
                placement="bottomRight"
                title={
                  '最初にガイダンス動画を視聴した後、診断受検を開始してください。受検後、診断結果PDFダウンロードやレポートの読み方動画視聴が可能になります。'
                }
                color={'var(--brand-primary)'}
                key={'orange'}
              >
                <QuestionCircleOutlined
                  style={{ fontSize: '25px', color: 'var(--white)' }}
                />
              </Tooltip>
            }
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Card
                  hoverable
                  cover={
                    <div style={{ position: 'relative' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="パーソナリティ診断：ガイダンス"
                        src={thumbnailURL + '90502_02.png'}
                      />
                      <div className="duration">
                        <span>
                          {('00' + 3).slice(-2)} : {('00' + 26).slice(-2)}
                        </span>
                      </div>
                    </div>
                  }
                  onClick={() => handleCardClick('1179829426')}
                >
                  <div className="video-card-title">ガイダンス 動画視聴</div>
                </Card>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable={false}
                    cover={
                      <img
                        alt="診断受検完了"
                        src={thumbnailURL + '90502_01_d.png'}
                      />
                    }
                  >
                    <div className="video-card-title">診断受検完了</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={true}
                    onClick={() => handleCardClick('takeSurvey')}
                    cover={
                      <img
                        alt="診断受検はこちら"
                        src={thumbnailURL + '90502_01.png'}
                      />
                    }
                  >
                    <div className="video-card-title">診断受検はこちら</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable={true}
                    onClick={showConfirm}
                    cover={
                      <img
                        alt="診断結果PDFダウンロード"
                        src={thumbnailURL + '90502_03.png'}
                      />
                    }
                  >
                    <div className="video-card-title">診断結果PDFダウンロード</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <img
                        alt="診断結果PDFダウンロード"
                        src={thumbnailURL + '90502_03_d.png'}
                      />
                    }
                  >
                    <div className="video-card-title">診断結果PDFダウンロード</div>
                  </Card>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {surveyStatus ? (
                  <Card
                    hoverable
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="パーソナリティ診断：レポートの読み方"
                          src={thumbnailURL + '90502_02.png'}
                        />
                        <div className="duration">
                          <span>
                            {('00' + 7).slice(-2)} : {('00' + 26).slice(-2)}
                          </span>
                        </div>
                      </div>
                    }
                    onClick={() => handleCardClick('1179830588')}
                  >
                    <div className="video-card-title">レポートの読み方 動画視聴</div>
                  </Card>
                ) : (
                  <Card
                    hoverable={false}
                    cover={
                      <div style={{ position: 'relative' }}>
                        <img
                          style={{ width: '100%' }}
                          alt="パーソナリティ診断：レポートの読み方"
                          src={thumbnailURL + '90502_02_d.png'}
                        />
                      </div>
                    }
                  >
                    <div className="video-card-title">レポートの読み方 動画視聴</div>
                  </Card>
                )}
              </Col>
            </Row>
          </Card>
        ) : (
          <></>
        )}
        <br />
      </div>
      {/* モーダルが開いているときのみレンダリング */}
      {viewModal && (
        <div>
          <Modal
            title="動画再生"
            open={viewModal}
            onOk={handleOk}
            onCancel={handleCancel}
            styles={{ body: { overflowX: 'scroll' } }}
            width={1000}
            footer={null}
            destroyOnHidden={true} // モーダルを閉じるときに子要素を完全に破棄
            maskClosable={false} // マスククリックで閉じるのを無効化
          >
            {videoId && ( // videoIdがある場合のみレンダリング
              <Vimeo
                key={`vimeo-${videoId}-${Date.now()}`} // ユニークなkeyを生成
                video={videoId}
                className="vimeo pc"
                responsive
                autoplay={true}
                speed={true}
                paused={paused}
                onReady={handleReady} // プレイヤー準備完了時の処理
              />
            )}
          </Modal>
        </div>
      )}
      <Modal
        title="サーベイ結果ファイル生成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
}

export default Course90502Page;
